export default {
  locale: 'en',
  defaultUnits: {
    weight: 'kg',
    height: 'cm',
    inputUnitAngleConverter: 'deg',
    outputUnitAngleConverter: 'rad',
    inputUnitAreaConverter: 'm2',
    outputUnitAreaConverter: 'ha',
    inputUnitBaseConverter: '10',
    outputUnitBaseConverter: '2',
    inputUnitDataStorageConverter: 'KB',
    outputUnitDataStorageConverter: 'MB',
    inputUnitEnergyConverter: 'Wh',
    outputUnitEnergyConverter: 'J',
    inputUnitFrequencyConverter: 'Hz',
    outputUnitFrequencyConverter: 'rpm',
    inputUnitLengthConverter: 'cm',
    outputUnitLengthConverter: 'm',
    inputUnitPressureConverter: 'Pa',
    outputUnitPressureConverter: 'psi',
    inputUnitSpeedConverter: 'km/h',
    outputUnitSpeedConverter: 'knot',
    inputUnitTimeConverter: 'd',
    outputUnitTimeConverter: 'min',
    inputUnitVolumeConverter: 'gal',
    outputUnitVolumeConverter: 'l',
    inputUnitWeightConverter: 'kg',
    outputUnitWeightConverter: 'lb',
    inputUnitForceConverter: 'N',
    outputUnitForceConverter: 'lbf',
    inputUnitFlowRateConverter: 'm3/s',
    outputUnitFlowRateConverter: 'l/s',
    inputUnitTemperatureConverter: 'C',
    outputUnitTemperatureConverter: 'F',
    inputUnitDensityConverter: 'kg/m3',
    outputUnitDensityConverter: 'lb/cu-ft',
    inputUnitAspectRatioConverter: '4:3'
  }
}
